"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 13.5a.965.965 0 01-.676-.273L1.03 6.095a.92.92 0 010-1.32.97.97 0 011.351 0L9 11.244l6.619-6.47a.97.97 0 011.351 0 .92.92 0 010 1.32l-7.294 7.132A.964.964 0 019 13.5z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2422_3559",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 18,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 13.5a.965.965 0 01-.676-.273L1.03 6.095a.92.92 0 010-1.32.97.97 0 011.351 0L9 11.244l6.619-6.47a.97.97 0 011.351 0 .92.92 0 010 1.32l-7.294 7.132A.964.964 0 019 13.5z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2422_3559)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#007AFF",
    d: "M0 0h18v18H0z"
  })));
}
var _default = exports["default"] = SvgArrow;